// Mock data for Ochoa Herrera & Asociados landing page

export const heroData = {
  headline: "Asesoría Legal con Calidez Humana",
  subtitle: "En momentos difíciles, encontrar el respaldo legal adecuado marca la diferencia. Estamos aquí para escucharte y defender tus derechos.",
  ctaText: "Agenda tu consulta por WhatsApp",
  whatsappNumber: "527771495537",
  backgroundImage: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d"
};

export const introData = {
  title: "Ochoa Herrera & Asociados",
  description: "Somos un despacho jurídico en Cuernavaca con más de 11 años de experiencia. No solo brindamos respaldo y certeza legal, sino un acompañamiento personal con enfoque humanista. Entendemos que cada caso representa preocupaciones, familias y futuros. Por eso, nuestra prioridad es escuchar, comprender y diseñar estrategias legales que protejan lo que más valoras."
};

export const servicesData = [
  {
    id: 1,
    title: "Derecho Civil",
    description: "Contratos, arrendamientos, propiedad y sucesiones. Protegemos tu patrimonio con asesoría clara y efectiva.",
    image: "https://images.unsplash.com/photo-1590099543482-3b3d3083a474"
  },
  {
    id: 2,
    title: "Derecho Penal",
    description: "Defensa y representación en procesos penales. Tu libertad y tranquilidad son nuestra prioridad.",
    image: "https://images.unsplash.com/photo-1760089449852-e8cade7feb53"
  },
  {
    id: 3,
    title: "Derecho Familiar",
    description: "Divorcios, pensiones alimenticias, custodia y convivencias. Resolvemos conflictos familiares con sensibilidad y profesionalismo.",
    image: "https://images.unsplash.com/photo-1603058817990-2b9a9abbce86"
  },
  {
    id: 4,
    title: "Derecho Laboral",
    description: "Despidos injustificados, finiquitos y conflictos laborales. Defendemos tus derechos como trabajador o empleador.",
    image: "https://images.unsplash.com/photo-1593115057322-e94b77572f20"
  },
  {
    id: 5,
    title: "Derecho Mercantil",
    description: "Operaciones comerciales, contratos mercantiles y resolución de controversias empresariales.",
    image: "https://images.unsplash.com/photo-1607778914885-787b06728b07"
  },
  {
    id: 6,
    title: "Derecho Corporativo",
    description: "Constitución de sociedades, gobierno corporativo y reestructuraciones empresariales.",
    image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da"
  },
  {
    id: 7,
    title: "Derecho Administrativo",
    description: "Trámites ante autoridades, licencias y permisos. Navegamos la burocracia por ti.",
    image: "https://images.unsplash.com/photo-1768839722927-df0ef3188f6d"
  },
  {
    id: 8,
    title: "Juicio de Amparo",
    description: "Protección constitucional de tus garantías individuales ante actos de autoridad.",
    image: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c"
  }
];

export const aboutData = {
  title: "Más que un despacho, un refugio legal",
  content: "En Ochoa Herrera & Asociados, con sede en Cuernavaca, llevamos más de 11 años transformando la incertidumbre en tranquilidad. Sabemos que detrás de cada expediente hay una persona, una familia, un sueño. Nuestro enfoque humanista nos lleva a escuchar primero, analizar con rigor y actuar con determinación. No solo ofrecemos asesoría legal; brindamos acompañamiento genuino en cada etapa del proceso. Tu confianza es nuestro mayor compromiso."
};

export const contactData = {
  title: "Contacto",
  subtitle: "Sabemos que enfrentar un problema legal puede ser abrumador. No estás solo.",
  ctaPhrase: "Hablemos hoy. Da el primer paso hacia tu tranquilidad.",
  ctaButton: "Enviar mensaje por WhatsApp",
  whatsappNumber: "527771495537",
  phone: "777 149 5537",
  email: "contacto@ochoaherrerayasociados.com",
  address: {
    street: "Fray Bartolomé de las Casas, número 17, despacho 8C",
    location: "Interior de plaza Arcángel",
    neighborhood: "Col. Centro",
    city: "Cuernavaca, Morelos",
    zipCode: "C.P. 62000",
    mapsLink: "https://maps.app.goo.gl/sYZZYkiiRVXhotXi6"
  }
};
